module.exports = __webpack_public_path__ + "img/ic-star-off.510c6ef8.svg";